import styled from '@emotion/styled'

export const ItalicText = styled.span`
  font-style: italic;
`

export const ContactContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 1023px) {
    flex-direction: column;
  }
`

export const ContactList = styled.section`
  flex-grow: 0;
  flex-basis: 30%;
`

export const ContactImage = styled.section`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  max-width: 50%;

  @media (max-width: 1250px) {
    width: 100%;
  }
  @media (max-width: 1023px) {
    margin-top: 3rem;
    max-width: 100%;
    padding-left: 0;
  }
  @media (max-width: 1440px) {
    max-width: 725px;
  }
`

export const ContactNav = styled.nav`
  margin-top: 1rem;
`
